import { ObjectLike } from '@/types/objectlike.types';
import { iShare } from './review.types';

export class Share implements iShare {
  reviewId: string;

  reviewUserId: string;

  reviewGamertag: string;

  constructor(reviewId: string, reviewUserId: string, reviewGamertag: string) {
    this.reviewId = reviewId;
    this.reviewUserId = reviewUserId;
    this.reviewGamertag = reviewGamertag;
  }

  toObject(): ObjectLike {
    return {
      reviewId: this.reviewId,
      reviewUserId: this.reviewUserId,
      reviewGamertag: this.reviewGamertag,
    };
  }
}
